<header>
    <strong class="subtitle">
        <span>{{ 'phones' | translate }}</span>
    </strong>

    <button class="has-btn-icon" (click)="add()" matButton="outlined"><i class="icon icon-plus"></i> {{ 'add_phone' | translate }}</button>
</header>

<div class="titles">
    <span class="col"></span>
    <span class="col-2">{{ 'phone' | translate }}*</span>
    <span class="col-3">{{ 'ext' | translate }}</span>
    <span class="col-4">{{ 'primary' | translate }}</span>
    <span class="col-5">{{ 'phone_type' | translate }}</span>
</div>

@for (phoneGroup of phoneGroups().controls; track phoneGroup; let i = $index) {
    <div class="form-row">
        <div class="col">
            @if (!phoneGroup.controls.isPrimary.value) {
                <span class="icon icon-cross red-bg" (click)="removePhone(i)"></span>
            }
        </div>
        <app-phone-info [group]="phoneGroup" [showPrimaryInfo]="true">
            <mat-radio-group radio name="phone-group" [formControl]="phoneGroup.controls.isPrimary">
                <mat-radio-button (change)="onChangePrimary(i)" [value]="true"></mat-radio-button>
            </mat-radio-group>
        </app-phone-info>
    </div>
}
